export const FormsComponents = () => {
  return (
    <div className="my-4">
      <p>Forms Components</p>
    </div>
  );
};

